import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ToggleCaptionUI from './tooglecaptionui';


export default class ToggleCaption extends Plugin {
  static get pluginName() {
    return 'ToggleCaption';
  }

  static get requires() {
    return [ ToggleCaptionUI];
  }
}
